
import React from "react";
import {
    Box,
    Typography,
    TextField,
    MenuItem,
    Button,
    Checkbox,
    FormControlLabel, FormControl, FormHelperText,
} from "@mui/material";
import SquareCheckbox from "../filters/squareCheckbox";
import {formControlDefaults, textFieldDefaults, textFieldSelectDefaults} from "../../../helpers/theme/defaultProps";
import {ErrorMessage, FormikProvider} from "formik";

const FIELD_WIDTH = 286;


function ProfileTextField({
                              name,
                              label,
                              required = false,
                              value,
                              onChange,
                              onBlur
                          }) {
    return (
        <Box sx={{position: "relative", width: "100%", height: 59,mb:1}}>
            <FormControl
                {...formControlDefaults}
            >
                <TextField
                    {...textFieldDefaults}
                    fullWidth
                    required={required}
                    variant="outlined"
                    size="small"
                    name={name}
                    label={label}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    InputLabelProps={{
                        sx: {
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontSize: 14,
                            color: "#111111",
                            "&.Mui-focused": {
                                color: "#111111",
                            },
                        },
                    }}
                    InputProps={{
                        sx: {
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontSize: 14,
                            "& .MuiInputBase-input": {
                                py: 1.1,
                                pl: 1,
                            },
                            "& fieldset": {
                                borderColor: "#111111",
                                borderWidth: 1,
                                borderRadius: "4px",
                            },
                            "&:hover fieldset": {
                                borderColor: "#111111",
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#111111",
                            },
                        },
                    }}
                />
                <FormHelperText>
                    <ErrorMessage name={name}/>
                </FormHelperText>
            </FormControl>
        </Box>
    );
}


function ProfileSelectField({
                                name,
                                label,
                                options,
                                required = false,
                                value,
                                onChange,
                                onBlur
                            }) {
    return (
        <Box sx={{position: "relative", width: "100%", height: 59,mb:1}}>
            <FormControl
                {...formControlDefaults}
            >
                <TextField
                    {...textFieldSelectDefaults}
                    select
                    fullWidth
                    required={required}
                    variant="outlined"
                    size="small"
                    name={name}
                    label={label}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    InputLabelProps={{
                        sx: {
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontSize: 14,
                            color: "#111111",
                            "&.Mui-focused": {
                                color: "#111111",
                            },
                        },
                    }}
                    InputProps={{
                        sx: {
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontSize: 14,
                            "& .MuiInputBase-input": {
                                py: 1.1,
                                pl: 1,
                            },
                            "& fieldset": {
                                borderColor: "#111111",
                                borderWidth: 1,
                                borderRadius: "4px",
                            },
                            "&:hover fieldset": {
                                borderColor: "#111111",
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#111111",
                            },
                        },
                    }}
                >
                    {options.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </TextField>
                <FormHelperText>
                    <ErrorMessage name={name}/>
                </FormHelperText>
            </FormControl>
        </Box>
    );
}

export default function AccountDetailsForm({
                                               formik,
                                               countryOptions = [],t
                                           }) {
    return (
        <FormikProvider value={formik}>
            <Box
                component="form"
                onSubmit={formik.handleSubmit}
                sx={{ maxWidth: 624, width: "100%" }}
            >
                {/* Περιγραφή πάνω από τη φόρμα */}
                <Typography
                    sx={{
                        fontFamily: "'Roboto Condensed', sans-serif",
                        fontSize: 16,
                        lineHeight: "120%",
                        color: "#000000",
                        mb: 3,
                    }}
                >
                    {t("Be sure you have updated your personal information if something changed.")}
                </Typography>


                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        // gap: 3,
                        // mb: 6,
                    }}
                >

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            gap: { xs: 2, md: 4 },
                        }}
                    >
                        <Box
                            sx={{
                                width: { xs: "100%", md: FIELD_WIDTH },
                                flexShrink: 0,
                            }}
                        >
                            <ProfileTextField
                                name="name"
                                label={t("Name")}
                                required
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Box>
                        <Box
                            sx={{
                                width: { xs: "100%", md: FIELD_WIDTH },
                                flexShrink: 0,
                            }}
                        >
                            <ProfileTextField
                                name="afm"
                                label={t('AFM')}
                                required
                                value={formik.values.afm}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            gap: { xs: 2, md: 4 },
                        }}
                    >
                        <Box
                            sx={{
                                width: { xs: "100%", md: FIELD_WIDTH },
                                flexShrink: 0,
                            }}
                        >
                            <ProfileTextField
                                name="company"
                                label={t("Company")}
                                value={formik.values.company}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Box>
                        <Box
                            sx={{
                                width: { xs: "100%", md: FIELD_WIDTH },
                                flexShrink: 0,
                            }}
                        >
                            <ProfileTextField
                                name="email"
                                label={t("Email")}
                                required
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            gap: { xs: 2, md: 4 },
                        }}
                    >
                        <Box
                            sx={{
                                width: { xs: "100%", md: FIELD_WIDTH },
                                flexShrink: 0,
                            }}
                        >
                            <ProfileSelectField
                                name="country"
                                label={t("Country")}
                                value={formik.values.country}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                options={countryOptions}
                                required
                            />
                        </Box>
                        <Box
                            sx={{
                                width: { xs: "100%", md: FIELD_WIDTH },
                                flexShrink: 0,
                            }}
                        >
                            <ProfileTextField
                                name="phone"
                                label={t("Phone")}
                                value={formik.values.phone}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                required
                            />
                        </Box>
                    </Box>
                </Box>


                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2.5,
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: "'Zen Maru Gothic', sans-serif",
                            fontWeight: 900,
                            fontSize: 24,
                            lineHeight: "110%",
                            textTransform: "uppercase",
                            color: "#000000",
                        }}
                    >
                        {t("Change Password")}
                    </Typography>


                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2.5,
                        }}
                    >

                        <Box sx={{ maxWidth: 624 }}>
                            <ProfileTextField
                                name="currentPassword"
                                label={t("Current Password")}
                                type="password"
                                value={formik.values.currentPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Box>


                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", md: "row" },
                                gap: { xs: 2, md: 4 },
                            }}
                        >
                            <Box
                                sx={{
                                    width: { xs: "100%", md: FIELD_WIDTH },
                                    flexShrink: 0,
                                }}
                            >
                                <ProfileTextField
                                    name="password"
                                    label={t("New Password")}
                                    type="password"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Box>
                            <Box
                                sx={{
                                    width: { xs: "100%", md: FIELD_WIDTH },
                                    flexShrink: 0,
                                }}
                            >
                                <ProfileTextField
                                    name="confirmPassword"
                                    label={t('Confirm Password')}
                                    type="password"
                                    value={formik.values.confirmPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            mt: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                        }}
                    >
                        <FormControlLabel
                            control={
                                <SquareCheckbox
                                    checked={formik.values.newsletterOptIn || false}
                                    onChange={(e) =>
                                        formik.setFieldValue("newsletterOptIn", e.target.checked)
                                    }
                                    sx={{
                                        p: 0,
                                        mr: 1,
                                        "& .MuiSvgIcon-root": { fontSize: 18 },
                                    }}
                                />
                            }
                            label={t("Register to our newsletter!")}
                            sx={{
                                m: 0,
                                "& .MuiTypography-root": {
                                    fontFamily: "'Roboto Condensed', sans-serif",
                                    fontSize: 14,
                                    color: "#111111",
                                },
                            }}
                        />

                        <FormControlLabel
                            control={
                                <SquareCheckbox
                                    checked={formik.values.promotionsOptIn || false}
                                    onChange={(e) =>
                                        formik.setFieldValue("promotionsOptIn", e.target.checked)
                                    }
                                    sx={{
                                        p: 0,
                                        mr: 1,
                                        "& .MuiSvgIcon-root": { fontSize: 18 },
                                    }}
                                />
                            }
                            label={t("Receive special offers from our partners!")}
                            sx={{
                                m: 0,
                                "& .MuiTypography-root": {
                                    fontFamily: "'Roboto Condensed', sans-serif",
                                    fontSize: 14,
                                    color: "#111111",
                                },
                            }}
                        />
                    </Box>

                    <Box sx={{ mt: 3 }}>
                        <Button
                            type="submit"
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                px: 2.5,
                                py: 1,
                                height: 37,
                                borderRadius: "120px",
                                backgroundColor: "#E5007E",
                                fontFamily: "'Zen Maru Gothic', sans-serif",
                                fontWeight: 900,
                                fontSize: 14,
                                textTransform: "uppercase",
                                color: "#FCFCFC",
                                "&:hover": {
                                    backgroundColor: "#c9006b",
                                },
                            }}
                        >
                            {t("Save")}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </FormikProvider>
    );
}
